module.exports = __webpack_public_path__ + "static/media/previewImageCard.8a9c8b44.png";